module.exports = __webpack_public_path__ + "static/media/buyer1.9365f845.jpg";